import { gql } from '@apollo/client'

export const RANKINGS = gql`
  query GetRankings($input: getRankInput!) {
    getRankings(input: $input) {
      aResults {
        nPoints
        _id
        nRank
        nRating
        sName
        sTeam
        oPlayer {
          eTagStatus
          oSeo {
            sSlug
            eStatus
          }
          sCountry
          sCountryFull
          oImg {
            sUrl
            sText
            sCaption
            sAttribute
          }
          sFullName
          sLastName
          sFirstName
        }
        dUpdated
        oTeams {
          eTagStatus
          oImg {
            sCaption
            sText
            sUrl
            sAttribute
          }
          oSeo {
            sSlug
            eStatus
          }
        }
      }
    }
  }
`
export const TOP_TEAMS = gql`
  query GetRankings($input: getRankInput!) {
    getRankings(input: $input) {
      aResults {
        _id
        sName
        oTeams {
          eTagStatus
          oSeo {
            sSlug
          }
        }
      }
    }
  }
`
export const UPCOMING_MATCHES = gql`
  query ListUpcomingMatches($input: listUpcomingMatchesInput) {
    listUpcomingMatches(input: $input) {
      _id
      oTeamA {
        sAbbr
        _id
        oImg {
          sUrl
          sText
          sAttribute
          sCaption
        }
      }
      oSeo {
        sSlug
      }
      oTeamB {
        sAbbr
        _id
        oImg {
          sUrl
          sText
          sCaption
          sAttribute
        }
      }
      dStartDate
    }
  }
`

export const GET_POPULAR_TEAMS = gql`
  query ListPopularTeams {
    listPopularTeams {
      _id
      oImg {
        sText
        sCaption
        sAttribute
        sUrl
      }
      sCountry
      sAltName
      sAbbr
      sTitle
      oSeo {
        sSlug
      }
    }
  }
`

export const CURRENT_SERIES_LIST = gql`
  query GetCurrentPopularSeries {
    getCurrentPopularSeries {
      aResults {
        _id
        oSeries {
          oCategory {
            oSeo {
              sSlug
            }
            oImg {
              sAttribute
              sText
              sCaption
              sUrl
            }
          }
          oSeo {
            sSlug
          }
          sTitle
          sSrtTitle
        }
      }
    }
  }
`
export const POPULAR_PLAYERS = gql`
  query OPlayer {
    getTrendingPlayers {
      oPlayer {
        sPlayingRole
        oImg {
          sUrl
        }
        sFullName
        sFullName
        oSeo {
          sSlug
        }
      }
      sTeam
      eRankType
    }
  }
`
export const POPULAR_TEAMS = gql`
  query ListPopularTeams {
    listPopularTeams {
      _id
      sTitle
      sAbbr
      sCountryFull
      eTagStatus
      oSeo {
        sSlug
      }
      oImg {
        sUrl
        sText
        sCaption
        sAttribute
      }
    }
  }
`
export const DID_YOU_KNOW = gql`
  query OData {
    getRandomDidYouKnowData {
      oData {
        dCreated
        dUpdated
        factStr
      }
    }
  }
`

export const GET_ODD_WIDGET = gql`
  query OMatch {
    getOddsWidget {
      oMatch {
        _id
        oWinPercent {
          sWinPercentage
          sTitle
        }
        aInning {
          matchFormat
        }
        oTeamScoreA {
          sScoresFull
          oTeam {
            _id
            sTitle
            sAbbr
            oImg {
              sUrl
            }
          }
        }
        oTeamScoreB {
          sScoresFull
          oTeam {
            _id
            sTitle
            sAbbr
            oImg {
              sUrl
            }
          }
        }
        oSeo {
          sSlug
        }
        sStatusStr
        dStartDate
        oSeries {
          sTitle
          sSrtTitle
        }
      }
      odds {
        outcomes {
          odds
          name
          iTeamId
        }
      }
    }
  }
`
